module.exports = __webpack_public_path__ + "media/images/company-logos/insel-spital-logo-360f630383265eb164d341ee6588e2dd.jpg";